export default __webpack_public_path__ + "static/media/how-we-do.528491bc.png";